<template>
  <div id="app">
    <div class="app-container">
      <Header v-if="!$route.meta.showPublic"></Header>
      <router-view/>
      <GoTop v-if="!$route.meta.showPublic"></GoTop>
      <Footer v-if="!$route.meta.showPublic"></Footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style scope>
.app-container{
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/App.vue